
/* reveals robustos con IntersectionObserver (no depende de gsap) */
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.16});
document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
/* polvo dorado en el hero — canvas ligero, rAF propio */
(function(){
  var c=document.getElementById('dust'); if(!c) return; var x=c.getContext('2d'); var W,H,P=[];
  function size(){ var r=c.getBoundingClientRect(); W=c.width=r.width; H=c.height=r.height; }
  size(); addEventListener('resize',size);
  for(var i=0;i<60;i++) P.push({x:Math.random()*W,y:Math.random()*H,r:Math.random()*1.8+.4,s:Math.random()*.3+.05,o:Math.random()*.5+.15});
  (function loop(){ requestAnimationFrame(loop); x.clearRect(0,0,W,H);
    for(var i=0;i<P.length;i++){var p=P[i];p.y-=p.s;if(p.y<-4){p.y=H+4;p.x=Math.random()*W;}
      x.beginPath();x.arc(p.x,p.y,p.r,0,6.3);x.fillStyle='rgba(199,154,78,'+p.o+')';x.fill();}
  })();
})();
